/**
 * Ανίχνευση «ο οργανισμός σας μεταφέρθηκε σε άλλο server».
 *
 * Ο παλιός server απαντά 410 Gone με { error: 'store_migrated', new_url } σε
 * κάθε αίτημα καταστήματος που μεταφέρθηκε (βλ. backend/utils/orgMigration.js).
 * Εδώ το πιάνουμε από ΟΠΟΥΔΗΠΟΤΕ και ειδοποιούμε τη MigrationScreen.
 *
 * ΓΙΑΤΙ ΚΑΙ ΣΤΟ fetch: η εφαρμογή κάνει ~377 απλές κλήσεις fetch και ~211 μέσω
 * axios. Ένα interceptor μόνο στο axios θα άφηνε τις μισές σελίδες να κάνουν
 * κλήσεις που αποτυγχάνουν σιωπηλά, χωρίς να καταλαβαίνει ο ταμίας γιατί.
 */

export const MIGRATION_EVENT = 'xentrix:store-migrated';

let movedTo: string | null = null;

export const getMovedTo = (): string | null => movedTo;

export const isMigrationPayload = (data: any): data is { new_url: string } =>
  !!data && data.error === 'store_migrated' && typeof data.new_url === 'string';

/** Καλείται μία φορά ανά φόρτωση — οι επόμενες ειδοποιήσεις αγνοούνται. */
export function reportMigration(newUrl: string) {
  if (!newUrl || movedTo) return;
  movedTo = newUrl;
  // Η συνεδρία στον παλιό server δεν έχει πια νόημα: τη σβήνουμε ώστε ούτε ένα
  // ξεχασμένο παράθυρο να μην ξαναπροσπαθήσει να δουλέψει εδώ.
  try {
    localStorage.removeItem('xentrix_token');
    localStorage.removeItem('xentrix_store_session');
  } catch { /* αποκλεισμένο storage — δεν πειράζει */ }
  window.dispatchEvent(new CustomEvent(MIGRATION_EVENT, { detail: { newUrl } }));
}

/**
 * Τυλίγει το window.fetch ώστε κάθε απάντηση 410 store_migrated να εμφανίζει
 * την οθόνη μεταφοράς. Αγγίζει ΜΟΝΟ τις απαντήσεις 410: οι υπόλοιπες περνούν
 * αυτούσιες, χωρίς clone και χωρίς καθυστέρηση. Διαβάζει από clone, ώστε ο
 * καλών να μπορεί ακόμα να διαβάσει το σώμα της απάντησης κανονικά.
 */
export function installFetchMigrationGuard() {
  const w = window as any;
  if (w.__xentrixFetchGuard) return;
  w.__xentrixFetchGuard = true;
  const original = window.fetch.bind(window);
  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const res = await original(...args);
    if (res.status === 410) {
      res.clone().json().then(data => {
        if (isMigrationPayload(data)) reportMigration(data.new_url);
      }).catch(() => { /* 410 χωρίς JSON — δεν μας αφορά */ });
    }
    return res;
  };
}
